import { get } from "./api";
import { Config, RemoteConfig, setupConfig } from "../../Config";

export const fetchEnvironment = async (options?: RequestInit): Promise<RemoteConfig> => {
    const remoteConfigs = await get<RemoteConfig>(`${Config.drupalEndpoint}/wpcr/api/config`, options);
    setupConfig(remoteConfigs);
    return remoteConfigs;
};
